import * as form from '../form';

export const legalInvestigationsHistory = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        Agency: form.radio(xitem.Agency),
        AgencyExplanation: form.textarea(xitem.AgencyExplanation), // PVQ only
        AgencyNotApplicable: form.notapplicable(xitem.AgencyNotApplicable), // SF Only
        Completed: form.datecontrol(xitem.Completed),
        CompletedNotApplicable: form.notapplicable(xitem.CompletedNotApplicable),
        Issued: form.text(xitem.Issued),
        Granted: form.datecontrol(xitem.Granted),
        GrantedNotApplicable: form.notapplicable(xitem.GrantedNotApplicable),
        ClearanceGranted: form.branch(xitem.ClearanceGranted),
        ClearanceLevel: form.clearancelevel(xitem.ClearanceLevel),
        ClearanceLevelNotApplicable: form.notapplicable(xitem.ClearanceLevelNotApplicable),
      },
    };
  });
  const clearanceHistoryItems = ((data.ClearanceHistoryList || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        Agency: form.radio(xitem.Agency),
        AgencyExplanation: form.textarea(xitem.AgencyExplanation),
        AgencyNotApplicable: form.notapplicable(xitem.AgencyNotApplicable) // SF Only
      },
    };
  });
  return {
    HasHistory: form.branch(data.HasHistory),
    List: form.collection(items, (data.List || {}).branch),
    HasClearanceHistory: form.branch(data.HasClearanceHistory),
    ClearanceHistoryList: form.collection(clearanceHistoryItems, (data.ClearanceHistoryList || {}).branch),
  };
};
